import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitString',
    standalone: false,
})
export class SplitStringPipe implements PipeTransform {
    transform(string: string, delimiter: string, index: number): string {
        return string.split(delimiter)[index] || '';
    }
}
